
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2fc9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2fc9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fJDR9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b749f9a0f897fef9$export$2e2bcd8739ae039; });
/* eslint-disable max-len */ const $b749f9a0f897fef9$var$langArr = {
    'header-title': {
        en: 'futuristic wireless speaker',
        ua: "\u0444\u0443\u0442\u0443\u0440\u0438\u0441\u0442\u0438\u0447\u043D\u0430 \u0431\u0435\u0437\u0434\u0440\u043E\u0442\u043E\u0432\u0430 \u043A\u043E\u043B\u043E\u043D\u043A\u0430"
    },
    'header-text': {
        en: "Luna\u2019s performance is balanced and smooth in all frequency ranges which makes the music both naturally pleasant and distinctly more layered.",
        ua: "\u0413\u0440\u0430 Luna \u0437\u0431\u0430\u043B\u0430\u043D\u0441\u043E\u0432\u0430\u043D\u0430 \u0442\u0430 \u043F\u043B\u0430\u0432\u043D\u0430 \u0443 \u0432\u0441\u0456\u0445 \u0447\u0430\u0441\u0442\u043E\u0442\u043D\u0438\u0445 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D\u0430\u0445, \u0449\u043E \u0440\u043E\u0431\u0438\u0442\u044C \u043C\u0443\u0437\u0438\u043A\u0443 \u043F\u0440\u0438\u0440\u043E\u0434\u043D\u043E \u043F\u0440\u0438\u0454\u043C\u043D\u043E\u044E \u0442\u0430 \u043F\u043E\u043C\u0456\u0442\u043D\u043E \u0431\u0456\u043B\u044C\u0448 \u0431\u0430\u0433\u0430\u0442\u043E\u0448\u0430\u0440\u043E\u0432\u043E\u044E."
    },
    specs: {
        en: 'specs',
        ua: "\u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0430"
    },
    buy: {
        en: 'buy',
        ua: "\u043A\u0443\u043F\u0438\u0442\u0438"
    },
    'nav-our-story': {
        en: 'our story',
        ua: "\u043D\u0430\u0448\u0430 \u0456\u0441\u0442\u043E\u0440\u0456\u044F"
    },
    'nav-about-us': {
        en: 'about us',
        ua: "\u043F\u0440\u043E \u043D\u0430\u0441"
    },
    'nav-features': {
        en: 'features',
        ua: "\u043E\u0441\u043E\u0431\u043B\u0438\u0432\u043E\u0441\u0442\u0456"
    },
    'nav-get-touch': {
        en: 'get in touch',
        ua: "\u0437\u0432'\u044F\u0437\u0430\u0442\u0438\u0441\u044C \u0437 \u043D\u0430\u043C\u0438"
    },
    'futuristic-design-title': {
        en: 'futuristic design',
        ua: "\u0444\u0443\u0442\u0443\u0440\u0438\u0441\u0442\u0438\u0447\u043D\u0438\u0439 \u0434\u0438\u0437\u0430\u0439\u043D"
    },
    'futuristic-design-text': {
        en: 'To give Luna a truly flawless look, we specifically picked aircraft grade aluminum as its material and adopted both three-dimensional stretch-bending technology and a high precision cold forging technique.',
        ua: "\u0429\u043E\u0431 \u043D\u0430\u0434\u0430\u0442\u0438 Luna \u0441\u043F\u0440\u0430\u0432\u0434\u0456 \u0431\u0435\u0437\u0434\u043E\u0433\u0430\u043D\u043D\u043E\u0433\u043E \u0432\u0438\u0433\u043B\u044F\u0434\u0443, \u043C\u0438 \u0441\u043F\u0435\u0446\u0456\u0430\u043B\u044C\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u043B\u0438 \u0430\u0432\u0456\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u0430\u043B\u044E\u043C\u0456\u043D\u0456\u0439 \u044F\u043A \u0439\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0456\u0430\u043B \u0456 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u043B\u0438 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0456\u044E \u0442\u0440\u0438\u0432\u0438\u043C\u0456\u0440\u043D\u043E\u0433\u043E \u0437\u0433\u0438\u043D\u0430\u043D\u043D\u044F \u043D\u0430 \u0440\u043E\u0437\u0442\u044F\u0433 \u0456 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0456\u044E \u0432\u0438\u0441\u043E\u043A\u043E\u0442\u043E\u0447\u043D\u043E\u0433\u043E \u0445\u043E\u043B\u043E\u0434\u043D\u043E\u0433\u043E \u043A\u0443\u0432\u0430\u043D\u043D\u044F."
    },
    'speaker-system-title': {
        en: 'tweeter speaker system',
        ua: "\u0442\u0432\u0456\u0442\u0435\u0440\u043D\u0430 \u0430\u043A\u0443\u0441\u0442\u0438\u0447\u043D\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0430"
    },
    'speaker-system-text': {
        en: 'To deliver a more layered sound performance better than a sole full-range speaker, our team equipped Luna with one more tweeter speaker responsible for high-frequency sound independently.',
        ua: "\u0429\u043E\u0431 \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0438\u0442\u0438 \u0431\u0456\u043B\u044C\u0448 \u0431\u0430\u0433\u0430\u0442\u043E\u0448\u0430\u0440\u043E\u0432\u0438\u0439 \u0437\u0432\u0443\u043A, \u043A\u0440\u0430\u0449\u0438\u0439, \u043D\u0456\u0436 \u0454\u0434\u0438\u043D\u0438\u0439 \u043F\u043E\u0432\u043D\u043E\u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D\u043D\u0438\u0439 \u0434\u0438\u043D\u0430\u043C\u0456\u043A, \u043D\u0430\u0448\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \u043E\u0441\u043D\u0430\u0441\u0442\u0438\u043B\u0430 Luna \u0449\u0435 \u043E\u0434\u043D\u0438\u043C \u0442\u0432\u0456\u0442\u0435\u0440\u043D\u0438\u043C \u0434\u0438\u043D\u0430\u043C\u0456\u043A\u043E\u043C, \u044F\u043A\u0438\u0439 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u0437\u0430 \u0432\u0438\u0441\u043E\u043A\u043E\u0447\u0430\u0441\u0442\u043E\u0442\u043D\u0438\u0439 \u0437\u0432\u0443\u043A \u043D\u0435\u0437\u0430\u043B\u0435\u0436\u043D\u043E."
    },
    'multiroom-system-title': {
        en: 'multiroom system',
        ua: "\u0431\u0430\u0433\u0430\u0442\u043E\u043A\u0456\u043C\u043D\u0430\u0442\u043D\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0430"
    },
    'multiroom-system-text': {
        en: 'Luna is natively compatible with your home Wi-Fi. Set up multiple speakers in different rooms to expand your music experience into the entire house.',
        ua: "Luna \u043D\u0430\u0442\u0438\u0432\u043D\u043E \u0441\u0443\u043C\u0456\u0441\u043D\u0430 \u0437 \u0434\u043E\u043C\u0430\u0448\u043D\u0456\u043C Wi-Fi. \u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0456\u0442\u044C \u043A\u0456\u043B\u044C\u043A\u0430 \u0434\u0438\u043D\u0430\u043C\u0456\u043A\u0456\u0432 \u0443 \u0440\u0456\u0437\u043D\u0438\u0445 \u043A\u0456\u043C\u043D\u0430\u0442\u0430\u0445, \u0449\u043E\u0431 \u0440\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438 \u043C\u0443\u0437\u0438\u0447\u043D\u0438\u0439 \u0434\u043E\u0441\u0432\u0456\u0434 \u0443 \u0432\u0441\u044C\u043E\u043C\u0443 \u0431\u0443\u0434\u0438\u043D\u043A\u0443."
    },
    'lighting-system-title': {
        en: 'intuitive lighting system',
        ua: "\u0456\u043D\u0442\u0443\u0457\u0442\u0438\u0432\u043D\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u043E\u0441\u0432\u0456\u0442\u043B\u0435\u043D\u043D\u044F"
    },
    'lighting-system-text': {
        en: 'An intuitive user interface allows you to adjust the hue and saturation of color for lighting that fits any mood and situation.',
        ua: "\u0406\u043D\u0442\u0443\u0457\u0442\u0438\u0432\u043D\u043E \u0437\u0440\u043E\u0437\u0443\u043C\u0456\u043B\u0438\u0439 \u0456\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0434\u043E\u0437\u0432\u043E\u043B\u044F\u0454 \u0440\u0435\u0433\u0443\u043B\u044E\u0432\u0430\u0442\u0438 \u0432\u0456\u0434\u0442\u0456\u043D\u043E\u043A \u0456 \u043D\u0430\u0441\u0438\u0447\u0435\u043D\u0456\u0441\u0442\u044C \u043A\u043E\u043B\u044C\u043E\u0440\u0456\u0432 \u0434\u043B\u044F \u043E\u0441\u0432\u0456\u0442\u043B\u0435\u043D\u043D\u044F, \u044F\u043A\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u0431\u0443\u0434\u044C-\u044F\u043A\u043E\u043C\u0443 \u043D\u0430\u0441\u0442\u0440\u043E\u044E \u0442\u0430 \u0441\u0438\u0442\u0443\u0430\u0446\u0456\u0457."
    },
    'designed-future-title': {
        en: 'Designed for the future',
        ua: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E \u0434\u043B\u044F \u043C\u0430\u0439\u0431\u0443\u0442\u043D\u044C\u043E\u0433\u043E"
    },
    'designed-future-text': {
        en: 'In 2014, a group of geeky industrial designers, engineering veterans and acoustic experts formed crazybaby. This is a bunch of passionate people who are crazy enough to think they can challenge the industry with disruptive audio products. ',
        ua: "\u0423 2014 \u0440\u043E\u0446\u0456 \u0433\u0440\u0443\u043F\u0430 \u043F\u0440\u043E\u043C\u0438\u0441\u043B\u043E\u0432\u0438\u0445 \u0434\u0438\u0437\u0430\u0439\u043D\u0435\u0440\u0456\u0432, \u0432\u0435\u0442\u0435\u0440\u0430\u043D\u0456\u0432 \u0442\u0435\u0445\u043D\u0456\u043A\u0438 \u0442\u0430 \u0435\u043A\u0441\u043F\u0435\u0440\u0442\u0456\u0432 \u0437 \u0430\u043A\u0443\u0441\u0442\u0438\u043A\u0438 \u0441\u0442\u0432\u043E\u0440\u0438\u043B\u0430 crazybaby. \u0426\u0435 \u0433\u0440\u0443\u043F\u0430 \u043F\u0440\u0438\u0441\u0442\u0440\u0430\u0441\u043D\u0438\u0445 \u043B\u044E\u0434\u0435\u0439, \u044F\u043A\u0456 \u043D\u0430\u0441\u0442\u0456\u043B\u044C\u043A\u0438 \u0431\u043E\u0436\u0435\u0432\u0456\u043B\u044C\u043D\u0456, \u0449\u043E\u0431 \u0434\u0443\u043C\u0430\u0442\u0438, \u0449\u043E \u043C\u043E\u0436\u0443\u0442\u044C \u043A\u0438\u043D\u0443\u0442\u0438 \u0432\u0438\u043A\u043B\u0438\u043A \u0456\u043D\u0434\u0443\u0441\u0442\u0440\u0456\u0457 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0440\u0443\u0439\u043D\u0456\u0432\u043D\u0438\u0445 \u0430\u0443\u0434\u0456\u043E\u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0456\u0432."
    },
    'luna-eye-title': {
        en: 'Luna eye',
        ua: "\u041C\u0456\u0441\u044F\u0447\u043D\u0435 \u043E\u043A\u043E"
    },
    'luna-eye-text': {
        en: 'Luna Eye is to the essence of this innovative light and audio system. It comprises an independent tweeter speaker, a light guiding component, a dome and a ring ornament.',
        ua: "Luna Eye \u2014 \u0441\u0443\u0442\u044C \u0446\u0456\u0454\u0457 \u0456\u043D\u043D\u043E\u0432\u0430\u0446\u0456\u0439\u043D\u043E\u0457 \u0441\u0438\u0441\u0442\u0435\u043C\u0438 \u043E\u0441\u0432\u0456\u0442\u043B\u0435\u043D\u043D\u044F \u0442\u0430 \u0430\u0443\u0434\u0456\u043E\u0441\u0438\u0441\u0442\u0435\u043C\u0438. \u0412\u0456\u043D \u0441\u043A\u043B\u0430\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437 \u043D\u0435\u0437\u0430\u043B\u0435\u0436\u043D\u043E\u0433\u043E \u0432\u0438\u0441\u043E\u043A\u043E\u0447\u0430\u0441\u0442\u043E\u0442\u043D\u043E\u0433\u043E \u0434\u0438\u043D\u0430\u043C\u0456\u043A\u0430, \u0441\u0432\u0456\u0442\u043B\u043E\u0432\u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430, \u043A\u0443\u043F\u043E\u043B\u0430 \u0442\u0430 \u043A\u0456\u043B\u044C\u0446\u0435\u0432\u043E\u0433\u043E \u043E\u0440\u043D\u0430\u043C\u0435\u043D\u0442\u0443."
    },
    'see-more': {
        en: 'See more about us',
        ua: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u043D\u0430\u0441"
    },
    quote: {
        en: 'It really took me by surprise honestly to have such full beautiful sound that coming out of this small compact device. And with the brush aluminum surface, it feels so familiar. Like my iPhone.',
        ua: "\u041C\u0435\u043D\u0435, \u0447\u0435\u0441\u043D\u043E \u043A\u0430\u0436\u0443\u0447\u0438, \u0441\u043F\u0440\u0430\u0432\u0434\u0456 \u0437\u0434\u0438\u0432\u0443\u0432\u0430\u043B\u043E \u0442\u0430\u043A\u0435 \u0447\u0443\u0434\u043E\u0432\u0435 \u0437\u0432\u0443\u0447\u0430\u043D\u043D\u044F, \u044F\u043A\u0435 \u0432\u0438\u0445\u043E\u0434\u0438\u0442\u044C \u0456\u0437 \u0446\u044C\u043E\u0433\u043E \u043C\u0430\u043B\u0435\u043D\u044C\u043A\u043E\u0433\u043E \u043A\u043E\u043C\u043F\u0430\u043A\u0442\u043D\u043E\u0433\u043E \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E. \u0410 \u0437\u0430\u0432\u0434\u044F\u043A\u0438 \u0449\u0456\u0442\u043A\u043E\u0432\u0456\u0439 \u0430\u043B\u044E\u043C\u0456\u043D\u0456\u0454\u0432\u0456\u0439 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u0456 \u0446\u0435 \u0432\u0438\u0433\u043B\u044F\u0434\u0430\u0454 \u0442\u0430\u043A \u0437\u043D\u0430\u0439\u043E\u043C\u043E. \u042F\u043A \u043C\u0456\u0439 iPhone."
    },
    'person-name': {
        en: 'Garrett Martin',
        ua: "\u0413\u0430\u0440\u0440\u0435\u0442 \u041C\u0430\u0440\u0442\u0456\u043D"
    },
    'person-profession': {
        en: 'Creative Director',
        ua: "\u041A\u0440\u0435\u0430\u0442\u0438\u0432\u043D\u0438\u0439 \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440"
    },
    features: {
        en: 'Features',
        ua: "\u041E\u0441\u043E\u0431\u043B\u0438\u0432\u043E\u0441\u0442\u0456"
    },
    connectivity: {
        en: 'Connectivity',
        ua: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F"
    },
    'hands-free': {
        en: 'Hands Free Wireless Audio',
        ua: "\u0411\u0435\u0437\u0434\u0440\u043E\u0442\u043E\u0432\u0430 \u0430\u0443\u0434\u0456\u043E\u0441\u0438\u0441\u0442\u0435\u043C\u0430 Hands Free"
    },
    multiroom: {
        en: 'Smart Multiroom System Set Up',
        ua: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0438 Smart Multiroom"
    },
    'party-mode': {
        en: 'Party Mode with 6.0 Units and above',
        ua: "\u0420\u0435\u0436\u0438\u043C \u0432\u0435\u0447\u0456\u0440\u043A\u0438 \u0437 \u043E\u0434\u0438\u043D\u0438\u0446\u044F\u043C\u0438 6.0 \u0456 \u0432\u0438\u0449\u0435"
    },
    'multi-speaker': {
        en: 'MESHNET Multi Speaker Network',
        ua: "\u041C\u0435\u0440\u0435\u0436\u0430 \u0437 \u0434\u0435\u043A\u0456\u043B\u044C\u043A\u043E\u043C\u0430 \u043A\u043E\u043B\u043E\u043D\u043A\u0430\u043C\u0438 MESHNET"
    },
    'app-features': {
        en: 'App Features',
        ua: "\u0424\u0443\u043D\u043A\u0446\u0456\u0457 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0438"
    },
    'customize-music': {
        en: 'Customize Music Schedule',
        ua: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0439\u0442\u0435 \u043C\u0443\u0437\u0438\u0447\u043D\u0438\u0439 \u0440\u043E\u0437\u043A\u043B\u0430\u0434"
    },
    'wake-up': {
        en: 'Wake Up with Favorite Songs',
        ua: "\u041F\u0440\u043E\u043A\u0438\u0434\u0430\u0439\u0441\u044F \u0437 \u0443\u043B\u044E\u0431\u043B\u0435\u043D\u0438\u043C\u0438 \u043F\u0456\u0441\u043D\u044F\u043C\u0438"
    },
    'home-detection': {
        en: 'Home Detection Auto Wake Up',
        ua: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u0440\u043E\u0437\u043F\u0456\u0437\u043D\u0430\u0432\u0430\u043D\u043D\u044F \u0431\u0443\u0434\u0438\u043D\u043A\u0443"
    },
    'color-wheel': {
        en: 'Color Wheel',
        ua: "\u041A\u043E\u043B\u044C\u043E\u0440\u043E\u0433\u0430 \u043F\u0430\u043B\u0456\u0442\u0440\u0430"
    },
    'sounds-music': {
        en: 'Sound & Music',
        ua: "\u0417\u0432\u0443\u043A & \u041C\u0443\u0437\u0438\u043A\u0430"
    },
    'fell-in-chest': {
        en: 'Feel-in-chest Base Power',
        ua: "\u0411\u0430\u0437\u043E\u0432\u0430 \u043F\u043E\u0442\u0443\u0436\u043D\u0456\u0441\u0442\u044C \u0432\u0456\u0434\u0447\u0443\u0442\u0442\u044F \u0432 \u0433\u0440\u0443\u0434\u044F\u0445"
    },
    'lossless-transmission': {
        en: 'Lossless Digital Audio Transmission',
        ua: "\u041F\u0435\u0440\u0435\u0434\u0430\u0447\u0430 \u0446\u0438\u0444\u0440\u043E\u0432\u043E\u0433\u043E \u0437\u0432\u0443\u043A\u0443 \u0431\u0435\u0437 \u0432\u0442\u0440\u0430\u0442"
    },
    'stereo-pairing': {
        en: 'Easy & Stable Stereo Pairing',
        ua: "\u041F\u0440\u043E\u0441\u0442\u0435 \u0442\u0430 \u0441\u0442\u0430\u0431\u0456\u043B\u044C\u043D\u0435 \u0441\u0442\u0435\u0440\u0435\u043E\u0437\u2019\u0454\u0434\u043D\u0430\u043D\u043D\u044F"
    },
    'high-frequency-sound': {
        en: 'Crisp and Clear High Frequency Sound',
        ua: "\u0427\u0456\u0442\u043A\u0438\u0439 \u0456 \u0447\u0438\u0441\u0442\u0438\u0439 \u0432\u0438\u0441\u043E\u043A\u043E\u0447\u0430\u0441\u0442\u043E\u0442\u043D\u0438\u0439 \u0437\u0432\u0443\u043A"
    },
    'cloud-music': {
        en: 'Streams from Cloud Music and Local Library',
        ua: "\u041F\u043E\u0442\u043E\u043A\u0438 \u0437 Cloud Music \u0456 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E\u0457 \u0431\u0456\u0431\u043B\u0456\u043E\u0442\u0435\u043A\u0438"
    },
    'auto-music': {
        en: 'Auto Music from Last Song Stopped',
        ua: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0430 \u0437\u0443\u043F\u0438\u043D\u043A\u0430 \u043C\u0443\u0437\u0438\u043A\u0438 \u0437 \u043E\u0441\u0442\u0430\u043D\u043D\u044C\u043E\u0457 \u043F\u0456\u0441\u043D\u0456"
    },
    'have-questions': {
        en: 'Do you have any questions?',
        ua: "\u041C\u0430\u0454\u0448 \u043F\u0438\u0442\u0430\u043D\u043D\u044F?"
    },
    'btn-send': {
        en: 'Send',
        ua: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438"
    },
    'rights-reserved': {
        en: "\xa9 2019 All rights reserved. Terms of Use & Privacy Policy",
        ua: "\xa9 2019 \u0423\u0441\u0456 \u043F\u0440\u0430\u0432\u0430 \u0437\u0430\u0445\u0438\u0449\u0435\u043D\u043E. \u0423\u043C\u043E\u0432\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0442\u0430 \u043F\u043E\u043B\u0456\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0456\u0434\u0435\u043D\u0446\u0456\u0439\u043D\u043E\u0441\u0442\u0456"
    }
};
var $b749f9a0f897fef9$export$2e2bcd8739ae039 = $b749f9a0f897fef9$var$langArr;

});


parcelRequire("fJDR9");

//# sourceMappingURL=Kickstarter.98704985.js.map
